// extracted by mini-css-extract-plugin
export default {"main":"RolProfesorSelector_main__m-T7k"};